export default __webpack_public_path__ + "static/media/personality-test-violet.0c00acd1.png";